<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>
    <div
      class="d-flex gap-5 align-items-center justify-content-between tw-px-[28px] tw-mb-[15px]"
      style="background-color: #33497b"
    >
      <div class="vue-tabs vue-tabs-type-1">
        <div class="nav-tabs-navigation">
          <div class="nav-tabs-wrapper">
            <ul role="tablist" class="nav nav-tabs px-0">
              <li
                class="tab"
                @click="handleTabChange(dataLang['referal_program_text_1'])"
                :class="{
                  active: activateTab == dataLang['referal_program_text_1'],
                }"
              >
                <a
                  href="#"
                  role="tab"
                  class="tabs__link px-30"
                  :class="{
                    active_tab:
                      activateTab == dataLang['referal_program_text_1'],
                  }"
                  ><span class="title title_center fsc-14 fw-normal">{{
                    dataLang["referal_program_text_1"]
                  }}</span></a
                >
              </li>
              <li
                class="tab"
                @click="handleTabChange(dataLang['referal_program_text_2'])"
                :class="{
                  active: activateTab == dataLang['referal_program_text_2'],
                }"
              >
                <a
                  href="#"
                  :class="{
                    active_tab:
                      activateTab == dataLang['referal_program_text_2'],
                  }"
                  class="tabs__link px-30"
                  ><span class="title title_center fsc-14 fw-normal">{{
                    dataLang["referal_program_text_2"]
                  }}</span></a
                >
              </li>
              <li
                class="tab"
                @click="handleTabChange(dataLang['referal_program_text_3'])"
                :class="{
                  active: activateTab == dataLang['referal_program_text_3'],
                }"
              >
                <a
                  href="#"
                  :class="{
                    active_tab:
                      activateTab == dataLang['referal_program_text_3'],
                  }"
                  class="tabs__link px-30"
                  ><span class="title title_center fsc-14 fw-normal">{{
                    dataLang["referal_program_text_3"]
                  }}</span></a
                >
              </li>
              <li
                class="tab"
                @click="handleTabChange(dataLang['referal_program_text_4'])"
                :class="{
                  active: activateTab == dataLang['referal_program_text_4'],
                }"
              >
                <a
                  href="#"
                  :class="{
                    active_tab:
                      activateTab == dataLang['referal_program_text_4'],
                  }"
                  class="tabs__link px-30"
                  ><span class="title title_center fsc-14 fw-normal">{{
                    dataLang["referal_program_text_4"]
                  }}</span></a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activateTab == dataLang['referal_program_text_1']">
      <div
        class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-text-white"
      >
        <div class="tw-flex tw-justify-between tw-items-end">
          <div class="tw-flex tw-items-end tw-gap-[20px]">
            <div class="tw-app-input-container multiselect-type-1">
              <label class="tw-app-input-container-label">
                {{ dataLang["referal_program_text_5"] }}
              </label>
              <BaseSelect
                class="!tw-w-[300px]"
                placeholder="Любой"
                selectLabel=""
                deselectLabel=""
                @input="
                  (data) =>
                    fillFilter({
                      name: 'referal_promocodes__id',
                      value: data.referal_promocodes__id,
                    })
                "
                v-model="selectsData.referal_promocodes__id"
                :options="selectsFilter?.referal_promocodes__id"
                label="referal_promocodes__code"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>

            <div class="tw-app-input-container multiselect-type-1">
              <label class="tw-app-input-container-label">
                {{ dataLang["referal_program_text_6"] }}
              </label>
              <BaseSelect
                class="!tw-w-[300px]"
                placeholder="Любой"
                selectLabel=""
                deselectLabel=""
                @input="
                  (data) =>
                    fillFilter({
                      name: 'companies__id',
                      value: data.value,
                    })
                "
                v-model="selectsData.companies__id"
                :options="selectsFilter?.companies__id"
                label="label"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>

            <div class="tw-app-input-container multiselect-type-1">
              <label class="tw-app-input-container-label">
                {{ dataLang["referal_program_text_8"] }}
              </label>
              <BaseSelect
                class="!tw-w-[300px]"
                placeholder="Любой"
                selectLabel=""
                deselectLabel=""
                @input="
                  (data) =>
                    fillFilter({
                      name: 'cities__id',
                      value: data.value,
                    })
                "
                v-model="selectsData.cities__id"
                :options="selectsFilter?.cities__id"
                label="label"
              >
                <template slot="noOptions">{{
                  dataLang["select_empty"]
                }}</template>
                <template slot="noResult">{{
                  dataLang["select_search_empty"]
                }}</template
                ><template slot="selectedLabel">{{
                  dataLang["select_selected"]
                }}</template>
                <template slot="deselectLabel">{{
                  dataLang["select_unselect"]
                }}</template>
              </BaseSelect>
            </div>

            <div class="tw-flex">
              <button
                @click="loadData()"
                type="button"
                class="tw-app-btn-primary"
              >
                {{ dataLang["reg_contract_main_10"] }}
              </button>
              <button
                @click="resetFilter"
                type="button"
                class="tw-app-btn-light"
              >
                Сбросить
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="tw-relative tw-px-[26px] tw-py-[15px]"
        style="min-height: 250px"
      >
        <BaseLoader v-if="localLoading"></BaseLoader>
        <div>
          <div class="tw-flex tw-justify-end tw-mb-[15px]">
            <TwBasePagination
              :page-count="numPages"
              :pagination-params="{
                ...paginationFinesStateParams,
                limit: limitPaginationValue,
              }"
              @updateLimitValue="updateLimitValue"
              :showLimitInput="true"
              :page-range="10"
              :click-handler="loadData"
            >
            </TwBasePagination>
          </div>
          <div>
            <ve-table
              class="fixed-header rest-style-table"
              style="width: 100%"
              :columns="columns"
              :table-data="dataTable"
              :border-x="true"
              :border-y="true"
              row-key-field-name="id"
              ref="mainTable"
              :eventCustomOption="eventCustomOption"
              v-if="!localLoading"
              :cell-style-option="cellStyleOption"
              :checkbox-option="{
                selectedRowChange: selectedRowChange,
                selectedAllChange: selectedAllChange,
                hideSelectAll: true,
              }"
              :clickHighlight="false"
              :rowStyleOption="{
                hoverHighlight: true,
              }"
              :cellSelectionOption="{ enable: false }"
            >
            </ve-table>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="activateTab == dataLang['referal_program_text_2']"
      class="tw-p-[15px_28px]"
    >
      <div class="tw-flex tw-gap-[30px] tw-text-[12px]">
        <div class="tw-bg-[#EEF4FA] tw-text-[#0056AF] tw-p-[10px_15px] tw-grow">
          {{ dataLang["referal_program_text_27"] }}
        </div>
        <div class="tw-bg-white tw-rounded-[8px] tw-p-[10px_15px]">
          {{ dataLang["referal_program_text_28"] }}:
          <span class="tw-text-[#23B14D] tw-font-[600]">{{
            referralIncomesData?.amount
              ? referralIncomesData?.amount?.split(".")?.join(",")
              : 0
          }}</span>
        </div>
      </div>

      <div class="tw-flex tw-justify-end tw-my-[15px]">
        <TwBasePagination
          :page-count="numPagesIncomes"
          :pagination-params="paginationReferalIncomesParams"
          :showLimitInput="false"
          :page-range="10"
          :margin-pages="0"
          :click-handler="loadIncomes"
        >
        </TwBasePagination>
      </div>

      <div
        v-for="income in referralIncomesData?.rows"
        class="tw-flex tw-gap-[30px] tw-items-center tw-bg-white tw-rounded-[8px] tw-mb-[8px] tw-p-[12px_15px]"
      >
        <div class="tw-text-[15px] tw-font-[600] tw-text-[#23B14D]">
          + {{ income.referer_money__amount?.split(".")?.join(",") }} ₽
        </div>
        <div>
          <div class="tw-text-[14px] tw-text-forTitle tw-mb-[5px]">
            {{ income.referer_money__title }}
          </div>
          <div class="tw-text-[12px] tw-text-forText">
            {{ income.referer_money__text }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="activateTab == dataLang['referal_program_text_3']">
      <div
        class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-text-white"
      >
        <div
          class="tw-flex tw-justify-start tw-items-end tw-gap-[10px] tw-text-white"
        >
          <div class="tw-app-input-container !tw-w-auto !tw-grow-0">
            <label class="tw-app-input-container-label">
              {{ dataLang["referal_program_text_18"] }}
            </label>
            <BaseInputNew
              class="tw-w-[400px]"
              @keyupEnter="onSearchInn()"
              inputClass="tw-app-input-dark"
              placeholder=""
              :value="searchInnString"
              @input="(data) => (searchInnString = data.value)"
              :additionalParams="{}"
            />
          </div>
          <div class="tw-flex tw-flex-row">
            <button
              @click="onSearchInn()"
              type="button"
              class="tw-app-btn-primary"
            >
              Поиск
            </button>
            <button
              @click="(searchInnString = ''), (searchInnState = null)"
              type="button"
              class="tw-app-btn-light"
            >
              Сбросить
            </button>
          </div>
        </div>
      </div>
      <div
        class="tw-mx-[26px] tw-mt-[10px] tw-text-[12px]"
        v-if="searchInnState"
        :style="{
          color:
            searchInnState.color == 'cell-status-red' ? '#FF3A20' : '#23B14D',
        }"
        v-html="searchInnState.message"
      ></div>
    </div>

    <div
      v-if="activateTab == dataLang['referal_program_text_4']"
      class="tw-px-[26px]"
    >
      <div class="tw-text-[12px] tw-text-forTitle">
        {{ dataLang["referal_program_text_20"] }}
      </div>

      <div>
        <div class="tw-my-[15px] tw-flex tw-items-center tw-gap-[10px]">
          <button
            class="tw-app-btn-primary"
            @click="$modal.show('addNewPromo')"
          >
            <img
              :src="require(`@/assets/icons/addwhite.svg`)"
              width="13.5"
              height="13.5"
              class="tw-my-[-5px]"
            />
            Добавить
          </button>
          <button class="tw-app-btn-primary-outline" @click="deleteRow">
            <img
              :src="require(`@/assets/icons/minus-dark.svg`)"
              width="13.5"
              height="13.5"
              class="tw-my-[-5px]"
            />
            Удалить
          </button>
          <a
            :href="qrLink"
            target="_blank"
            class="tw-app-btn-external"
            @click="onSearchInn"
          >
            Создать QR код
          </a>
        </div>
      </div>

      <div class="tw-relative tw-h-full" style="min-height: 250px">
        <BaseLoader v-if="localLoading"></BaseLoader>
        <div class="overflow-auto_" style="min-height: 400px">
          <ve-table
            class="fixed-header rest-style-table"
            style="width: 100%"
            :columns="columnsPromo"
            :table-data="selectsFilter?.referal_promocodes__id"
            :border-x="true"
            :border-y="true"
            row-key-field-name="referal_promocodes__id"
            ref="mainTable"
            :eventCustomOption="eventCustomOption"
            :cell-style-option="cellStyleOption"
            :checkbox-option="{
              selectedRowChange: selectedRowChange,
              selectedAllChange: selectedAllChange,
              hideSelectAll: false,
            }"
            :clickHighlight="false"
            :rowStyleOption="{
              hoverHighlight: true,
            }"
            :cellSelectionOption="{ enable: false }"
          >
          </ve-table>
        </div>
      </div>
    </div>

    <BaseModal
      name="addNewPromo"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen=""
      @beforeClose="beforeClose"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('addNewPromo')"
        ></button>
        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["referal_program_text_25"] }}
          </div>

          <BaseInputNew
            inputClass="tw-app-input-type-3 tw-mb-[15px]"
            :value="newPromoString"
            @input="(data) => (newPromoString = data.value)"
            :additionalParams="{}"
          />
          <div
            v-if="errorAddPromoData"
            class="tw-text-danger tw-mt-[15px] tw-mb-[30px]"
          >
            <template v-if="errorAddPromoData?.message">{{
              errorAddPromoData?.message
            }}</template>
          </div>
          <div>Реф. ссылка создастся автоматически</div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('addNewPromo')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="sendData"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import EventBus from "@/event-bus";
import { debounce } from "lodash";

export default {
  components: {
    VeTable,
  },

  data() {
    return {
      limitPaginationValue: 50,
      referralIncomesData: {},
      searchInnString: "",
      searchInnState: null,
      newPromoString: "",
      errorAddPromoData: null,
      typePin: "",
      fullSum: 0,
      callbackForSum: () => {},
      summForPayment: 0,
      summForPaymentWithPercent: 0,
      foundsList: {},
      localLoading: true,
      statisticsFromMainRequest: {},
      dataTable: [],
      dataTablePromo: [],
      activeSelectRowsMultiple: [],
      filter: [],
      activateTab: "",
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      selectTimeTopFilter: {
        dateCreatedStart: [],
        dateCreatedEnd: [],
      },
      activePagePagination: {},
      pincode: "",
      totalOnType: 0,
      dataForModal: {},
      aboutPageInfo: null,
      dataOfErrors: null,
      senderSmsPreset: null,
      peremText: "",
      typeOpenCancel: "",
      codeFromSms: "",
      selectsDataForModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsFromModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsData: {
        referal_promocodes__id: [],
        companies__id: [],
        cities__id: [],
      },
      selectsFilter: {
        referal_promocodes__id: [],
        companies__id: [],
        cities__id: [],
      },
      eventCustomOption: {
        // z
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {},
      },
      qrLink: null,
    };
  },

  methods: {
    getQr() {
      GeneralService.get(`/referal/qr`)
        .then((data) => {
          this.qrLink = data?.data?.data?.link;
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ошибка при запросе url для QR", {
            duration: 5000,
          });
        });
    },
    loadIncomes(val) {
      const params = { ...this.paginationReferalIncomesParams, page: val ?? 1 };
      GeneralService.get(`/referal/finance/table`, { params })
        .then((res) => {
          this.referralIncomesData = res.data.data;

          this.getIncomesAll({
            total: res.data.data.total,
            count: res.data.data.count,
            limit: params.limit,
            page: val,
          });
        })
        .catch((e) => {
          console.log(2222, e);
        });
    },
    beforeClose() {
      this.newPromoString = "";
    },
    sendData() {
      this.errorAddPromoData = null;
      GeneralService.editOrCreate(`/referal/promo`, {
        referal_promocodes__code: this.newPromoString.trim(),
      })
        .then((data) => {
          console.log(data);
          this.newPromoString = "";
          this.$toast.success(data.data.message);
          this.$modal.hide("addNewPromo");
          this.loadData();
        })
        .catch((e) => {
          this.errorAddPromoData = e.response.data;
          this.$toast.error(e.response.data.message);
        });
    },
    onSearchInn() {
      if (this.searchInnString.length) {
        GeneralService.get(`/referal/inn?inn=${this.searchInnString}`)
          .then((data) => {
            console.log(data);
            this.searchInnState = data.data;
          })
          .catch((e) => {
            console.log(e);

            this.$toast.error("Неизвестная ошибка при поиске ИНН", {
              duration: 5000,
            });
          });
      }
    },
    /// ОБРАБОТЧИК ПЕРЕХОДА ПО ВКЛАДКАМ
    async handleTabChange(newTab, oldTab) {
      if (newTab !== oldTab) {
        if (newTab === this.dataLang["referal_program_text_2"])
          this.loadIncomes(1);
        this.activateTab = newTab;

        this.searchInnString = "";
        this.searchInnState = null;

        await this.resetFilter();
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    deleteRow() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete(`/referal/promo/${this.activeSelectRowsMultiple}`)
          .then((data) => {
            this.$toast.success(data.data.message);
          })
          .catch((e) => {
            this.activeSelectRowsMultiple = [];
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.activeSelectRowsMultiple = [];
            this.$modal.hide("deleteRow");
            this.loadData();
          });
      }
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    resetFilter() {
      this.selectsData.companies__id = [];
      this.selectsData.cities__id = [];
      this.selectsData.referal_promocodes__id = [];
      this.filter = [];
      this.loadData();
    },

    onCloseModal() {
      this.currentId = null;
      this.updatedValues = {};
      this.dataForModal = {};
      this.activeSelectRowsMultiple = [];
      this.selectsFromModal.objectsVehicle = [];
      this.selectsFromModal.typeVehicles = [];
    },
    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/referal/promo/table`)
          .then((data) => {
            this.selectsFilter.referal_promocodes__id = data.data.data.rows;
          })
          .catch((e) => {
            this.$toast.error(
              "Неизвестная ошибка при загрузке списка промокодов",
              { duration: 5000 }
            );
          }),
      ]).then(() => {
        GeneralService.get(`/referal/referer/table`, {
          params: {
            // ...this.paginationFinesStateParams,
            limit: this.limitPaginationValue,
            page: page,
            where: this.filter?.length ? JSON.stringify(this.filter) : null,
          },
        })
          .then((data) => {
            this.dataTable = data.data.data.rows.map((el, index) => ({
              ...el,
              id: index,
            }));
            this.totalOnType = data.data.data.total;

            let dataForStrangeCompanies = data.data.filters.companies;
            if (!(dataForStrangeCompanies instanceof Array)) {
              this.selectsFilter.companies__id = Object.values(
                dataForStrangeCompanies
              ).map((el) => {
                return {
                  label: el,
                  value: el,
                };
              });
            }

            let dataForStrangeCities = data.data.filters.cities;
            if (!(dataForStrangeCities instanceof Array)) {
              if (!this.selectsFilter.cities__id?.length) {
                Object.keys(dataForStrangeCities).forEach((el) => {
                  this.selectsFilter.cities__id.push({
                    label: dataForStrangeCities[el],
                    value: el,
                  });
                });
              }
            }
            this.getFinesAll(data.data.data);

            if (this.activateTab === this.dataLang["referal_program_text_2"])
              this.loadIncomes();
            this.localLoading = false;
          })
          .catch((e) => {
            console.log(e);
            this.localLoading = false;
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
    ...mapActions("referalIncomesPagination", ["getIncomesAll"]),
  },
  mounted() {
    this.loadData();
    this.getQr();
  },
  beforeMount() {},
  created() {
    this.activateTab = this.dataLang["referal_program_text_1"];
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapState("referalIncomesPagination", ["paginationReferalIncomesParams"]),
    ...mapGetters("finesPagination", ["numPages"]),
    ...mapGetters("referalIncomesPagination", { numPagesIncomes: "numPages" }),

    computedTabParams() {
      switch (this.activateTab) {
        case this.dataLang["register_object_owners_text_3"]:
          return {
            url: "fiz",
          };
        case this.dataLang["register_object_owners_text_4"]:
          return {
            url: "ip",
          };
        case this.dataLang["register_object_owners_text_5"]:
          return {
            url: "ur",
          };
      }
    },

    // columnsPromo

    columnsPromo() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },
        {
          field: "referal_promocodes__code",
          key: "1622336",
          title: this.dataLang["referal_program_text_5"],
          align: "center",
          width: "8%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        // {
        //   field: 'referal_promocodes__link',
        //   key: '534534543',
        //   title: this.dataLang['referal_program_text_24'],
        //   align: 'start',
        //   width: '23%',
        //   ellipsis: {
        //     showTitle: true,
        //     lineClamp: 1
        //   }
        // },
        {
          field: "referal_promocodes__id",
          key: "62341",
          // title: this.dataLang['referal_program_text_29'],
          title: this.dataLang["referal_program_text_24"],
          align: "start",
          width: "30%",
          // ellipsis: {
          //   showTitle: true,
          //   lineClamp: 1
          // },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return [
              h(
                "span",
                { style: { "margin-right": "20px" } },
                row.referal_promocodes__link
              ),
              <img
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(
                      row.referal_promocodes__link
                    );
                    this.$toast.success("Текст успешно скопирован!");
                  } catch (err) {
                    console.error("Ошибка при копировании: ", err);
                    // Можно добавить fallback, если не работает
                  }
                }}
                style={"cursor: pointer; width: 24px; height: 24px"}
                src={require(`@/assets/icons/copy.svg`)}
              />,
            ];
          },
        },
        {
          field: "referal_promocodes__id",
          key: "62341",
          // title: this.dataLang['referal_program_text_29'],
          title: this.dataLang["referal_program_text_30"],
          align: "start",
          width: "30%",
          // ellipsis: {
          //   showTitle: true,
          //   lineClamp: 1
          // },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return [
              h(
                "span",
                { style: { "margin-right": "20px" } },
                row.referal_promocodes__link2
              ),
              <img
                class={!row.referal_promocodes__link2 ? "d-none" : ""}
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(
                      row.referal_promocodes__link2
                    );
                    this.$toast.success("Текст успешно скопирован!");
                  } catch (err) {
                    console.error("Ошибка при копировании: ", err);
                    // Можно добавить fallback, если не работает
                  }
                }}
                style={"cursor: pointer; width: 24px; height: 24px"}
                src={require(`@/assets/icons/copy.svg`)}
              />,
            ];
          },
        },
        {
          field: "referal_promocodes__id",
          key: "62341",
          // title: this.dataLang['referal_program_text_29'],
          title: this.dataLang["referal_program_text_31"],
          align: "start",
          width: "30%",
          // ellipsis: {
          //   showTitle: true,
          //   lineClamp: 1
          // },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return [
              h(
                "span",
                { style: { "margin-right": "20px" } },
                row.referal_promocodes__link3
              ),
              <img
                class={!row.referal_promocodes__link3 ? "d-none" : ""}
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(
                      row.referal_promocodes__link3
                    );
                    this.$toast.success("Текст успешно скопирован!");
                  } catch (err) {
                    console.error("Ошибка при копировании: ", err);
                    // Можно добавить fallback, если не работает
                  }
                }}
                style={"cursor: pointer; width: 24px; height: 24px"}
                src={require(`@/assets/icons/copy.svg`)}
              />,
            ];
          },
        },
      ];
    },

    columns() {
      return [
        {
          field: "referal_promocodes__code",
          key: "1622336",
          title: this.dataLang["referal_program_text_5"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companies__id",
          key: "534534543",
          title: this.dataLang["referal_program_text_6"],
          align: "center",
          width: "5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "cities__name",
          key: "62341",
          title: this.dataLang["referal_program_text_8"],
          align: "center",
          width: "20%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companies__created_at",
          key: "1334441",
          title: this.dataLang["referal_program_text_10"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span
                title={
                  row.companies__created_at
                    ? this.$time(row.companies__created_at).format(
                        `${this.userSetting.company__tempalte_date}`
                      )
                    : ""
                }
              >
                {row.companies__created_at
                  ? this.$time(row.companies__created_at).format(
                      `${this.userSetting.company__tempalte_date}`
                    )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "days",
          key: "1334871",
          title: this.dataLang["referal_program_text_11"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "objects",
          key: "133341",
          title: this.dataLang["referal_program_text_12"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "profit",
          key: "13132341",
          title: this.dataLang["referal_program_text_13"],
          align: "center",
          width: "15%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
      ];
    },
  },
};
</script>
